import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoiginImage from '../assets/images/forgot_password_image.png';
import Logo from '../assets/images/logo_image.png';
import { ValidateForgotPassword } from '../assets/validation';
import AuthAction from '../store/actions/AuthAction';

function ForgetPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loggedIn } = useSelector((state) => state.authentication);

  // reset login status
  useEffect(() => {
    if (loggedIn) {
      navigate('/dashboard');
    }
  }, [loggedIn, navigate]);

  return (
    <Box className="invoiceAppLoginWrap">
      <Grid container spacing={2}>
        <Grid item xs={6} md={6}>
          <Box className="loginLeftBg">
            <img src={LoiginImage} alt="Login" />
          </Box>
        </Grid>
        <Grid item xs={6} md={6}>
          <Box className="loginRightForm">
            <Box
              className="loginFormWrap"
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
              }}
            >
              <Formik
                initialValues={{
                  email: ''
                }}
                enableReinitialize
                validationSchema={ValidateForgotPassword}
                onSubmit={(values, { setErrors, setSubmitting }) => {
                  dispatch(AuthAction.forgetPassword(values, setErrors, setSubmitting, navigate));
                }}
              >
                {({
                  errors,
                  touched,
                  values,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting
                }) => (
                  <form onSubmit={handleSubmit}>
                    <img src={Logo} alt="Logo" />
                    <Box className="logninInner">
                      <Typography variant="h3" gutterBottom component="" mb={2}>
                        Forgot Password
                      </Typography>
                      {/* <Typography
                        variant="body1"
                        align="center"
                        className="subtitle"
                        component="p"
                        mb={2}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                        tempor incididunt ut labore et dolore magna aliqua.
                      </Typography> */}
                      <Paper elevation={0} sx={{ background: 'none' }}>
                        <TextField
                          error={errors.email && touched.email}
                          label="Email ID"
                          placeholder="Enter Email ID"
                          fullWidth
                          name="email"
                          value={values.email}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          helperText={errors.email && touched.email && errors.email}
                          margin="normal"
                          variant="outlined"
                          required={false}
                          InputLabelProps={{ required: true }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="start">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  edge="end"
                                  disabled
                                  sx={{
                                    bgcolor: 'secondary.main',
                                    '&.Mui-disabled': {
                                      bgcolor: 'secondary.main'
                                    },
                                    '&:hover': {
                                      borderColor: 'secondary.main',
                                      borderWidth: '1px',
                                      borderStyle: 'solid'
                                    }
                                  }}
                                >
                                  <i className="icon-mail" />
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                        />
                        <Button
                          type="submit"
                          className="submit_btn"
                          variant="contained"
                          sx={{ mt: 5, mb: 1 }}
                          fullWidth
                          color="secondary"
                          size="large"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                        </Button>
                        <Typography
                          className="forgetPasswordLink"
                          variant="body1"
                          mt={2}
                          align="center"
                          sx={{
                            color: 'text.main',
                            opacity: '1 !important'
                          }}
                        >
                          Back to Login? <Link to="/">Click Here</Link>
                        </Typography>
                      </Paper>
                    </Box>
                  </form>
                )}
              </Formik>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ForgetPassword;
